















































import { defineComponent, PropType, toRefs } from '@nuxtjs/composition-api';
import { SfProductCard, SfProductCardSkeleton } from '~/components/StorefrontUi';
import { useImage } from '~/composables';
import type { Product } from '~/modules/catalog/product/types';
import { Aggregation } from '@vue-storefront/magento-types';

import CategoryProductPrice from '~/modules/catalog/category/components/views/CategoryProductPrice.vue';
import UserComListingBanner from '~/modules/usercom/components/UsercomListingBanner.vue';
import { useProductsWithCommonProductCardProps } from './useProductsWithCommonCardProps';

export default defineComponent({
  components: {
    CategoryProductPrice,
    SfProductCard,
    SfProductCardSkeleton,
    UserComListingBanner,
  },
  props: {
    products: {
      type: Array as PropType<Product[]>,
      required: true,
    },
    activeCategoryName: {
      type: String,
      default: '',
    },
    aggregations: {
      type: Array as PropType<Aggregation[]>,
      required: true,
    },
    loading: Boolean,
  },
  emits: ['click:wishlist', 'click:add-to-cart'],
  setup(props) {
    const {
      imageSizes: { productCard: imageSize },
    } = useImage();
    const { products, aggregations } = toRefs(props);
    const { productsWithCommonProductCardProps } = useProductsWithCommonProductCardProps({
      products,
      aggregations,
    });

    return {
      imageSize,
      productsWithCommonProductCardProps,
    };
  },
});
